import { FundWithDetailsEntity } from '../../Entities/Fund.WithDetails.Entity';
import { FundTxApiCalls } from './Fund.FrontEnd.Tx.Api.Calls';

export class FundWithDetailsTxApiCalls extends FundTxApiCalls {
    protected static _Entity = FundWithDetailsEntity;
}
